// Stable keys for the fixed set of chip placeholders.
const CHIP_KEYS = ["a", "b", "c", "d", "e", "f"];

/**
 * Placeholder for the year/class group filter while the school taxonomy loads —
 * a column heading bar plus a few chip placeholders, mirroring the GroupFilter
 * layout so the sidebar doesn't shift when the real filter arrives.
 */
export const GroupFilterSkeleton = () => (
  <div className="flex min-w-0 flex-col gap-2">
    <div className="h-3 w-10 animate-pulse rounded bg-interface-neutral-2" />
    <div className="flex flex-col gap-1.5">
      {CHIP_KEYS.map((key) => (
        <div
          key={key}
          className="h-11 w-full animate-pulse rounded-lg bg-interface-neutral-2"
        />
      ))}
    </div>
  </div>
);
